import Component from "inferno-component";
import "./Logo.css";


export default class Logo extends Component {
   render() {
      return (
         <div className="Logo" style={this.props.style}>
            <div>
               <span className="Logo-o">
                  <span className="Logo-o1">o</span><span className="Logo-o2">o</span><span className="Logo-o3">o</span>
               </span>

               in<sup className="Logo-3">3</sup><sup>3</sup>s.com

               {this.props.children}
            </div>
         </div>
      );
   }
};



// WEBPACK FOOTER //
// ./src/Logo.js